export enum TrafficTicketStatusEnum {
  Opened = 0,
  Paid = 1
}